/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GameHealthFeature } from './GameHealthFeature';
import {
    GameHealthFeatureFromJSON,
    GameHealthFeatureFromJSONTyped,
    GameHealthFeatureToJSON,
    GameHealthFeatureToJSONTyped,
} from './GameHealthFeature';
import type { GameTrackingHealthStatus } from './GameTrackingHealthStatus';
import {
    GameTrackingHealthStatusFromJSON,
    GameTrackingHealthStatusFromJSONTyped,
    GameTrackingHealthStatusToJSON,
    GameTrackingHealthStatusToJSONTyped,
} from './GameTrackingHealthStatus';

/**
 * 
 * @export
 * @interface GameHealthResponse
 */
export interface GameHealthResponse {
    /**
     * 
     * @type {string}
     * @memberof GameHealthResponse
     */
    gameId: string;
    /**
     * 
     * @type {GameTrackingHealthStatus}
     * @memberof GameHealthResponse
     */
    status: GameTrackingHealthStatus;
    /**
     * 
     * @type {string}
     * @memberof GameHealthResponse
     */
    statusReason?: string;
    /**
     * 
     * @type {Array<GameHealthFeature>}
     * @memberof GameHealthResponse
     */
    gepFeatureBreakdown: Array<GameHealthFeature>;
    /**
     * 
     * @type {number}
     * @memberof GameHealthResponse
     */
    lastGepEventAt?: number;
    /**
     * 
     * @type {number}
     * @memberof GameHealthResponse
     */
    computedAt?: number;
}



/**
 * Check if a given object implements the GameHealthResponse interface.
 */
export function instanceOfGameHealthResponse(value: object): value is GameHealthResponse {
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('gepFeatureBreakdown' in value) || value['gepFeatureBreakdown'] === undefined) return false;
    return true;
}

export function GameHealthResponseFromJSON(json: any): GameHealthResponse {
    return GameHealthResponseFromJSONTyped(json, false);
}

export function GameHealthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameHealthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'],
        'status': GameTrackingHealthStatusFromJSON(json['status']),
        'statusReason': json['statusReason'] == null ? undefined : json['statusReason'],
        'gepFeatureBreakdown': ((json['gepFeatureBreakdown'] as Array<any>).map(GameHealthFeatureFromJSON)),
        'lastGepEventAt': json['lastGepEventAt'] == null ? undefined : json['lastGepEventAt'],
        'computedAt': json['computedAt'] == null ? undefined : json['computedAt'],
    };
}

export function GameHealthResponseToJSON(json: any): GameHealthResponse {
    return GameHealthResponseToJSONTyped(json, false);
}

export function GameHealthResponseToJSONTyped(value?: GameHealthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
        'status': GameTrackingHealthStatusToJSON(value['status']),
        'statusReason': value['statusReason'],
        'gepFeatureBreakdown': ((value['gepFeatureBreakdown'] as Array<any>).map(GameHealthFeatureToJSON)),
        'lastGepEventAt': value['lastGepEventAt'],
        'computedAt': value['computedAt'],
    };
}

